import { AvatarSkeleton } from "@circleco/compass/components/AvatarSkeleton";
import { Skeleton } from "@circleco/compass/components/Skeleton";

export const CommunityMemberSkeleton = () => (
  <li
    className="border-primary bg-primary group rounded-xl border-[1px] p-6 first:mt-4 first:md:mt-0"
    data-testid="community-member-skeleton"
  >
    <div className="flex w-full gap-x-4">
      {/* 64px, matching the avatar the loaded row renders. */}
      <AvatarSkeleton size="2xl" />
      <section className="flex min-w-0 flex-1 flex-col gap-y-3">
        <div className="flex flex-col gap-y-2">
          <Skeleton className="h-4 w-16" shape="pill" />
          <Skeleton className="h-3.5 w-1/2" shape="pill" />
          <Skeleton className="h-2.5 w-3/4" shape="pill" />
        </div>
        <div className="flex gap-2">
          <Skeleton className="h-6 w-16 rounded-full" shape="pill" />
          <Skeleton className="h-6 w-20 rounded-full" shape="pill" />
        </div>
      </section>
    </div>
  </li>
);
